import { axiosInstance } from "@/api/apiClient";
import {
  OnboardingApi,
  OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest,
  OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest,
  OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest,
  OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest,
  OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest,
  OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";

const api = new OnboardingApi(undefined, BASE_API, axiosInstance);

export const getBusinessOnboardingForm = async (
  payload: OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest
) => {
  return api.usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm.bind(api)(
    payload
  );
};

export const submitRecommendationForm = async (
  payload: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest
) => {
  return api.usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm.bind(
    api
  )(payload, { accessLevel: "public" } as CustomAxiosRequestConfig);
};

export const updateRecommendationForm = async (
  payload: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest,
  options?: CustomAxiosRequestConfig
) => {
  return api.usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm.bind(
    api
  )(payload, options);
};

export const getRecommendationFormByEmail = async (
  payload: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest
) => {
  return api.usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail.bind(
    api
  )(payload, { accessLevel: "public" } as CustomAxiosRequestConfig);
};

export const getSignUpStage = async (
  payload: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest
) => {
  return api.usersViewsNinjaPreSaleBusinessInformationGetSignupStage.bind(api)(
    payload,
    { accessLevel: "public" } as CustomAxiosRequestConfig
  );
};

export const getRecommendationForm = async (
  payload: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest = {}
) => {
  return api.usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm.bind(
    api
  )(payload);
};
